import { createSlice } from '@reduxjs/toolkit'

const generalSlice = createSlice({
    name: 'general',
    initialState: {
        navHeight: {},
        categories: [],
        colors: [],
    },
    reducers: {
        fetchNavHeightAction: (state, action) => {
            state.navHeight = action.payload
        },
        fetchCategoriesAction: (state, action) => {
            state.categories = action.payload
        },
        fetchColorsAction: (state, action) => {
            state.colors = action.payload
        },
    }

})

export const {fetchNavHeightAction, fetchCategoriesAction, fetchColorsAction} = generalSlice.actions

export default generalSlice